import { render, staticRenderFns } from "./ConditionUserRights.vue?vue&type=template&id=3b2b3a04&scoped=true&"
import script from "./ConditionUserRights.vue?vue&type=script&lang=ts&"
export * from "./ConditionUserRights.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2b3a04",
  null
  
)

export default component.exports